import { render } from "./VehicleBadgesCard.vue?vue&type=template&id=5e6325ee&scoped=true"
import script from "./VehicleBadgesCard.vue?vue&type=script&lang=js"
export * from "./VehicleBadgesCard.vue?vue&type=script&lang=js"

import "./VehicleBadgesCard.vue?vue&type=style&index=0&id=5e6325ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6325ee"]])

export default __exports__